export default __webpack_public_path__ + "static/media/hero.3b2241e7.gif";